import { Accordion, AccordionDetails, AccordionSummary, Box, Typography, useTheme } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PlusIcon from '@/assets/icons/plus-circle.svg?react'
import MinusIcon from '@/assets/icons/minus-circle.svg?react'
import { CustomAccordionProps, CustomAccordionType } from "./types";
import { useMemo, useState } from "react";
import { getStyles } from "./utils";
import { FONT_PRIMARY, FONT_SECONDARY } from "@/theme/typography";

const CustomAccordion = <T extends CustomAccordionType>({ label, icon = null, type, children }: CustomAccordionProps<T>) => {
  const theme = useTheme();
  const [open, setOpen] = useState<boolean>(false);

  const styles = useMemo(() => getStyles(type, theme), [type, theme]);

  return (
    <Accordion 
      onChange={(_, expanded) => {
        setOpen(expanded)
      }} 
      expanded={open} 
      sx={styles.accordion} 
      disableGutters
    >
      <AccordionSummary expandIcon={type === "primary" ? <ExpandMoreIcon /> : (open ? <MinusIcon /> : <PlusIcon />)}>
        {icon}
        <Typography sx={{
          fontFamily:{xs:FONT_SECONDARY, md:FONT_PRIMARY},
          fontSize: { xs: "1rem", md: "1.125rem" },
          fontWeight: "700"
        }}>{label}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={styles.box}>
          {children}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default CustomAccordion;